import api from '../index'

export interface OpenImConversationSummary {
  conversation_id: string
  conversation_type: number
  target_user_id: number
  target_user: {
    id: number
    username: string
    nickname: string
    avatar: string
  } | null
  is_pinned: boolean
  recv_msg_opt: number
  max_seq: number
  min_seq: number
  unread_count: number
  latest_message: {
    send_id: string
    recv_id: string
    sender_name: string
    sender_face_url: string
    content_type: number
    send_time_ms: number
    content_raw: string
    content_payload: Record<string, any> | null
    display_text: string
    media_url: string
  }
}

export interface OpenImMessageItem {
  seq: number
  send_id: string
  recv_id: string
  sender_nickname: string
  sender_face_url: string
  session_type: number
  content_type: number
  send_time_ms: number
  create_time_ms: number
  is_read: boolean
  content_raw: string
  content_payload: Record<string, any> | null
  display_text: string
  media_url: string
}

export interface OpenImConversationListPayload {
  list: OpenImConversationSummary[]
}

export interface OpenImConversationMessagePayload {
  conversation_id: string
  page: number
  per_page: number
  min_seq?: number
  max_seq?: number
  has_more: boolean
  list: OpenImMessageItem[]
}

export interface OpenImOrderChatPayload {
  order_id: number
  order_no: string
  buyer_user_id: number
  seller_user_id: number
  buyer_user: {
    id: number
    username: string
    nickname: string
    avatar: string
  } | null
  seller_user: {
    id: number
    username: string
    nickname: string
    avatar: string
  } | null
  messages: OpenImConversationMessagePayload
}

function userConversations(userId: number) {
  return api.get<unknown, { code: number, message: string, data: OpenImConversationListPayload }>(`/admin/user/user/${userId}/chat-conversations`)
}

interface OpenImUserMessageParams extends Record<string, unknown> {
  target_user_id: number
  conversation_id?: string
}

function userMessages(userId: number, query: OpenImUserMessageParams) {
  return api.get<unknown, { code: number, message: string, data: OpenImConversationMessagePayload }>(`/admin/user/user/${userId}/chat-messages`, {
    params: query,
  })
}

function orderMessages(orderId: number, params?: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: OpenImOrderChatPayload }>(`/admin/trade/order/${orderId}/chat-messages`, {
    params,
  })
}

const apiOpenim = {
  userConversations,
  userMessages,
  orderMessages,
}

export default apiOpenim
